"use client";

import { useSession } from "@/app/SessionProvider";

export const useCurrentUser = () => {
    const { session } = useSession();
    return session?.user;
};